export class ACCOUNTS {
    constructor(
        public ACCT_ID: number,
        public INV_ID: number,
        public ACCT_NAME: string,
        public ACCT_NO: string,
        public ISSUED_BY: number,
        public CREATED_BY: number,
        public PARTS: any,
        // public PARTISIPAN: any | null,
        public PARTISIPAN_ID: number,
        public PARTISIPAN_NAME: string,
    ) { }
}

export class ISSUE_ACCOUNTS {
    constructor(
        public ACCT_ID: number,
        public INV_ID: number,
        public ACCT_NAME: string,
        public ACCT_NO: string,
        public ISSUED_BY: number,
        public ISSUED_TYP: string,
        public BANK_ACCT_ID: number,
        public SEC_ACCT_ID: number,
        public BANK_REK_NO: string,
        public SEC_REK_NO: string,
        public CREATED_BY: number,
        public PARTS: any
    ) { }
}




// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/models/account.ts